import {getParent, types} from 'mobx-state-tree'

const FetcherMovingViolation = types
  .model('MovingViolation', {
    points: types.maybeNull(types.number),
    displayName: types.maybeNull(types.string),
    fineAmount: types.maybeNull(types.number),
    insuranceIncreaseEstimate3Years: types.maybeNull(types.number),
    trafficCodeArticles: types.maybeNull(types.array(types.string)),
  }).views(self => ({
    get isComplete() {
      return (
        typeof self.points === 'number' && self.points >= 0 &&
        typeof self.fineAmount === 'number' && self.fineAmount >= 0 &&
        typeof self.insuranceIncreaseEstimate3Years === 'number' && self.insuranceIncreaseEstimate3Years >= 0 &&
        self.trafficCodeArticles?.length > 0
        )
    }
  })).actions(self => ({
      afterCreate() {
        const parent = getParent(self)
        if (!self.displayName) {
          self.displayName = parent.formattedViolationName
        }
      }
  }))

export default FetcherMovingViolation
